// extracted by mini-css-extract-plugin
export default {"box-wrapper":"TenantBillingData_box-wrapper__2L91R","form-wrapper":"TenantBillingData_form-wrapper__GYHUn","field-wrapper":"TenantBillingData_field-wrapper__qaKBI"};